import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeProfileField } from 'redux/ducks/Post/Profile';
import { clearV2Form } from 'redux/ducks/Post/actions';
import ActionBar from 'scenes/V2/Shared/ActionBar';
import { trackMixpanelPageView } from 'helpers/post';
import { EVENT_TYPE_OPTIONS } from 'helpers/enums';
import classNames from 'classnames';
import { update } from 'redux/ducks/User';

class EventType extends Component {
  constructor(props) {
    super(props);
    props.initialize('EventType');
    props.clearV2Form();
  }

  componentDidMount() {
    trackMixpanelPageView('create-event/type');
  }

  onSelect = (type, href) => () => {
    if (type !== 'null')
      this.props.update({
        ...this.props.user,
        userPersona: type.replace(/^./, type[0].toUpperCase()),
      });

    if (type === 'contract') {
      this.props.onChangeProfile({
        name: 'eventType',
        value: type,
      });
      trackMixpanelPageView('LongTermForm');
      window.location.href = href;
    } else {
      this.props.onChangeProfile({
        name: 'eventType',
        value: 'per-diem',
      });
      this.props.history.push('/v2/create-event/setting');
    }
  };

  onSaveAndContinue = () => {
    const { eventType } = this.props.profile;
    if (!eventType) return;

    if (eventType === 'per-diem') this.props.history.push('/v2/create-event/setting');
  };

  renderChoiceCard = ({ title, description, selected, onClick }) => (
    <div className="choice selected" key={title}>
      <button className={classNames('type-button gotham-bold-font', { selected })} onClick={onClick}>
        {title} /{' '}
        <span className={classNames('type-tip nimbus-regular-font', { selected })}>{description}</span>
      </button>
    </div>
  );

  render() {
    const { eventType } = this.props.profile;

    return (
      <div className="eventType">
        <header>
          <div className="screen-title">How do you plan to use Go4?</div>
        </header>
        <main>
          {EVENT_TYPE_OPTIONS.map(({ title, description, value, href }) =>
            this.renderChoiceCard({
              title,
              description,
              selected: eventType === value,
              onClick: this.onSelect(value, href),
            })
          )}
        </main>
        <ActionBar
          nextDisabled={() => !eventType}
          editMode={this.props.editMode}
          currentStep="type"
          backTo="/dashboard"
          onSaveAndContinue={this.onSaveAndContinue}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.post.profile,
  authenticated: state.session.authenticated,
  user: state.session.currentUser,
});

const mapDispatchToProps = dispatch => ({
  onChangeProfile: ({ name, value }) => dispatch(changeProfileField({ name, value })),
  clearV2Form: () => dispatch(clearV2Form()),
  update: user => dispatch(update(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventType);
